export default "__VITE_ASSET__bUES8iv3__"